import React from 'react';
import './Home.css';
import { Link } from 'react-router-dom';
import SiteHeader from '../../shared/SiteHeader';
import { useEffect } from 'react';

const Home: React.FC = () => {
  useEffect(() => {
    document.title = 'Walk It With Me - Home';
  }, []);

  return (
    <>
      <SiteHeader />
      <div className="home-welcome container py-5">
        <div className="row justify-content-center">
          <div className="col-12 col-md-10 col-lg-8 text-center">
            <h1 className="display-5 fw-bold mb-3">Walk It With Me</h1>
            <p className="lead text-muted home-lead mx-auto">
              Walk It With Me uses AI to make thoughtful, contextual Bible exploration accessible —
              helping you understand Scripture in its original setting and see how its wisdom speaks
              into your everyday life.
            </p>
            <div className="d-flex justify-content-center gap-3">
              <Link to="/chat" className="btn btn-primary btn-lg mt-3">
                Get Started
              </Link>
              <Link to="/about" className="btn btn-outline-primary btn-lg mt-3">
                Learn More
              </Link>
            </div>
            <div>
              <img
                src="/LogoNoTitle.png"
                alt="Walk It With Me logo"
                className="img-fluid mt-4 home-logo"
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Home;
